module.exports = __webpack_public_path__ + "img/chat_icon.7fee49e9.svg";